import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { CurrenciesFilterCell } from 'components/Filter/FilterCell/CurrenciesFilterCell'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const interestRatesWalletThresholdsColumns: GridColumn[] = [
  {
    title: 'Currency',
    field: 'currency.name',
    filterCell: CurrenciesFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.currency.id) {
        return <td />
      }

      return <td>{props.dataItem.currency.id}</td>
    },
    width: 250,
    filterable: true,
    show: true,
  },
  {
    title: 'Max Amount',
    field: 'maxAmount',
    cell: (props: GridCellProps): JSX.Element => {
      return <td>{props.dataItem?.maxAmount}</td>
    },
    filterable: false,
    show: true,
  },
  {
    title: 'Min Interest Rate (%)',
    field: 'minInterestRate',
    cell: (props: GridCellProps): JSX.Element => {
      return <td>{props.dataItem?.minInterestRate}</td>
    },
    filterable: false,
    show: true,
  },
  {
    title: 'Max Interest Rate (%)',
    field: 'maxInterestRate',
    cell: (props: GridCellProps): JSX.Element => {
      return <td>{props.dataItem?.maxInterestRate}</td>
    },
    filterable: false,
    show: true,
  },
]

export default interestRatesWalletThresholdsColumns
